import { createTheme } from '@material-ui/core/styles'

export const theme = {
  palette: {
    primary: {
      main: '#00032e',
      defaultBorder: '1px solid #4E4B7C',
      defaultBackground: '#00032e',
      lightBackground: '#393760',
      defaultBorderRadius: '8px',
    },
    secondary: {
      main: '#f3537e',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        '&.Mui-disabled': {
          border: '1px solid #4E4B7C !important',
          color: '#4E4B7C !important',
        },
      },
    },
  },
  border: {
    primary: '1px solid #4E4B7C',
    secondary: '1px solid #f3537e',
  },
  zIndex: {
    modal: 500,
  },
}

export const defaultTheme = createTheme(theme) as unknown as typeof theme
